import { getIsMobileSearchParam } from '@wix/communities-blog-client-common';
import { flowRight } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProfileContentFrame from '../../../member-pages-common/components/profile-content-frame';
import styles from './profile-content-layout.scss';
import classNames from 'classnames';

const ProfileContentLayout = ({ title, titleClassName, titleFontClassName, children, isMobile }) => (
  <ProfileContentFrame
    title={title}
    headerClassName={styles.header}
    titleClassName={classNames(titleClassName, styles.title)}
    titleFontClassName={titleFontClassName}
  >
    {!isMobile && <hr className={styles.divider} />}
    <div className={styles.content}>{children}</div>
  </ProfileContentFrame>
);

ProfileContentLayout.propTypes = {
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  titleFontClassName: PropTypes.string,
  children: PropTypes.node,
  isMobile: PropTypes.bool,
};

export default flowRight(connect((state) => ({ isMobile: getIsMobileSearchParam(state) })))(ProfileContentLayout);
